import gql from "graphql-tag"

const fragment = gql`
  fragment adyenAdditionalDetails on AdyenAdditionalDetails {
    additionalData {
      recurringProcessingModel
    }
    merchantReference
    refusalReason
    pspReference
    resultCode
  }
`

export const toString = fragment.loc.source.body

export default fragment
